import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {CaseStatus} from '@shared/models/case-status.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil} from 'rxjs/operators';
import {Configuration} from '@shared/models/configuration';
import {AddCaseStatusCommand, DeleteCaseStatusCommand, UpdateCaseStatusCommand} from '@shared/commands/case-status.command';
import {Guid} from 'guid-typescript';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';

@Component({
    standalone: false,
    selector: 'app-dialog-field-status-options-editor',
  templateUrl: './dialog-field-status-options-editor.component.html',
  styleUrls: ['./dialog-field-status-options-editor.component.scss']
})
export class DialogFieldStatusOptionsEditorComponent extends DialogDefinitionEditorBase implements OnInit, OnDestroy {

  item: any;
  isOptionAdding: boolean;
  editingOption: any;
  exitingText: any;
  editForm: any;
  colors: Array<string> = [];
  selectedStatus: any;
  isStatusOptionSelectorVisible: boolean;
  caseStatuses$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  caseStatuses: Array<CaseStatus> = [];


  options: any = [];

  constructor(private formBuilder: FormBuilder, public changeDetectorRef: ChangeDetectorRef, private snackBarService: SnackBarService) {
    super();
    this.colors = ['#337aee', '#ff8800', '#de1758', '#8dcd4f', '#787878', '#ffcd20', '#08acc4', '#7c34de'];
    this.caseStatuses = [];
  }

  ngOnInit() {
    super.ngOnInit();
    this.isStatusOptionSelectorVisible = false;
    /*
    if (this.fieldDefinition.options) {
      this.fieldDefinition.options.forEach(option => {
        option.isEditing = false;
        if (!option.tags) {
          option.tags = [];
        }
      });
    }*/
    // this.editForm = this.formBuilder.group({
    //   title : ['', Validators.required],
    //   color: ['', Validators.required]
    // });

    this.editForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      color: new FormControl('', [Validators.required])
    });

    console.log(this.dialogField);

    if (this.dialogField?.value) {
      this.options = this.dialogField.value;
    }

    this.editForm.valueChanges.pipe(takeUntil(this.unSubscribe$)).subscribe((value) => {
      this.dynamicFormControl.setValue(this.options);
    });
  }

  startEditItem(option) {
    this.isStatusOptionSelectorVisible = false;
    console.log(option);
    this.isOptionAdding = false;
    if (this.editingOption) {
      this.editingOption.isEditing = false;
    }
    this.editingOption = option;
    this.editingOption.isEditing = true;
    this.resetForm(option);
  }

  removeOption(optionToRemove) {
    this.isStatusOptionSelectorVisible = false;
    const index = this.findIndex(optionToRemove);
    if (index !== -1) {
      this.options.splice(index, 1);
    }
    this.resetOptionEditing();
  }


  private findIndex(optionToRemove) {
    for (let index = 0; index < this.options.length; index++) {
      if (this.options[index].id === optionToRemove.id) {
        return index;
      }
    }
    return -1;
  }

  resetOptionEditing() {
    this.isStatusOptionSelectorVisible = false;
    this.isOptionAdding = false;
    if (this.editingOption) {
      this.editingOption.isEditing = false;
    }
    this.editingOption = null;
    this.exitingText = '';
    this.resetForm();
  }



  onSaveOption(event) {
    const title = this.editForm.controls['title'].value;
    const color = this.editForm.controls['color'].value;
    this.editingOption.text = title;
    this.editingOption.tags[0] = color;
    const index = this.findIndex(event);
    if(index !== -1) {
      this.options[index] = this.editingOption;
    }
    this.resetOptionEditing();
  }

  addOption() {
    this.resetOptionEditing();
    this.isOptionAdding = true;
    if (this.editingOption) {
      this.editingOption.isEditing = false;
    }
    this.editForm.controls['color'].setValue(this.colors[0]);
    this.changeDetectorRef.detectChanges();
    const element = document.getElementById('add-status-input');
    if (element) {
      element.scrollIntoView(false);
      element.focus();
    }
  }

  onSaveNewOption() {
    const title = this.editForm.controls['title'].value;
    const color = this.editForm.controls['color'].value;
    let isTitleExist = false;
    this.options.forEach(option1 => {
      if (option1.text === title) {
        if (this.editingOption) {
          if (option1.id === this.editingOption.id) {
            return;
          }
        }
        isTitleExist = true;
        return;
      }
    });
    if (isTitleExist) {
      this.snackBarService.showError('Status with same title already exist. Please choose a different title.');
      return;
    }
    const option = {
      'id': title,
      'text': title,
      'tags': [color],
      'order': this.options.length,
      'isCustom': true
    };
    this.options.push(option);
    this.resetOptionEditing();
  }

  resetForm(option?: any) {
    this.isStatusOptionSelectorVisible = false;
    if (option) {
      this.editForm.controls['title'].setValue(option.text);
      this.editForm.controls['color'].setValue(option.tags && option.tags.length > 0 ? option.tags[0] : '');
    } else {
      this.editForm.controls['title'].setValue('');
      this.editForm.controls['color'].setValue('');
    }
  }

  onOpenedChanged(event) {
    this.isStatusOptionSelectorVisible = true;
  }

  onSelectStatusColor(color) {
    this.isStatusOptionSelectorVisible = false;
    this.editForm.controls['color'].setValue(color);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

}
